import { useState } from "react";
import { Box, IconButton, Menu, MenuItem, Typography, Avatar, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import userIcon from "../../static/icons/user.svg";
import { useApp } from "../../context/AppContext";

export default function TopBar({ onOpenSidebar }) {
  const navigate = useNavigate();
  const { user, clearSession } = useApp();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleLogout = async () => {
    const access = localStorage.getItem("access");
    const refresh = localStorage.getItem("refresh");

    try {
      if (access && refresh) {
        await fetch("/logout/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access}`,
          },
          body: JSON.stringify({ refresh }),
        });
      }
    } catch {}

    clearSession();
    setAnchorEl(null);
    navigate("/", { replace: true });
  };

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        px: { xs: 1.25, sm: 2 },
        py: 1.1,
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        backgroundColor: "background.paper",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
        <IconButton onClick={onOpenSidebar} sx={{ color: "text.primary" }}>
          <MenuRoundedIcon sx={{ color: "primary.main", fontSize: 22 }} />
          <Typography
            sx={{
              fontSize: { xs: "0.92rem", sm: "1rem" },
              fontWeight: 700,
              color: "text.primary",
              whiteSpace: "nowrap",
              px: 1,
            }}
          >
            Menú
          </Typography>
        </IconButton>

        <Stack
          direction="row"
          spacing={0.8}
          alignItems="center"
          onClick={() => navigate("/admin")}
          sx={{
            cursor: "pointer",
            minWidth: 0,
            display: "flex",
          }}
        >
          <DashboardRoundedIcon sx={{ color: "primary.main", fontSize: 22 }} />
          <Typography
            sx={{
              fontSize: { xs: "0.92rem", sm: "1rem" },
              fontWeight: 700,
              color: "text.primary",
              whiteSpace: "nowrap",
            }}
          >
            Gestión de Marcadores
          </Typography>
        </Stack>
      </Stack>

      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{
          ml: "auto",
          px: 1,
          py: 0.75,
          borderRadius: "14px",
          cursor: "pointer",
          border: "1px solid rgba(140,15,44,0.12)",
          backgroundColor: "rgba(140,15,44,0.03)",
          maxWidth: { xs: "calc(100vw - 170px)", sm: "none" },
        }}
      >
        <Avatar src={userIcon} sx={{ width: 34, height: 34, bgcolor: "transparent" }} />
        <Typography
          sx={{
            fontSize: { xs: "0.84rem", sm: "0.92rem" },
            fontWeight: 600,
            color: "text.primary",
            maxWidth: { xs: 120, sm: 260 },
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {user?.correo || "Administrador"}
        </Typography>
        <KeyboardArrowDownRoundedIcon
          sx={{
            color: "text.secondary",
            fontSize: 22,
            transform: anchorEl ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform .2s ease",
          }}
        />
      </Stack>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={handleLogout} sx={{ gap: 1 }}>
          <LogoutRoundedIcon fontSize="small" />
          Cerrar sesión
        </MenuItem>
      </Menu>
    </Box>
  );
}